import React, { useCallback, useEffect, useState } from 'react';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Actions
import * as reservationActions from '../../../redux/reservations/actions';
import { fetchIncominSchematicReservation } from '../../../redux/reservations/actions';
// Third-party Library
import jmoment from 'moment-jalaali';
// Components
import List from './list';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
import ReserveDetailsModal from '../modals/ReserveDetails';
import InvoiceDetailsModal from '../modals/InvoiceDetails';
import * as menuItemsActions from '../../../redux/menuItems/actions';
import * as invoicesActions from '../../../redux/invoices/actions';
import ColorInfo from './colorInfo';
import HandelTableTimeStatus from './modal/HandelTableTimeStatus';

const SchematicReservation = () => {
  const {
    reservationsReducer: {
      // Schema
      incomingSchematicReservationsList,
      incomingSchematicReservationsLoading,
      // Invoice Detail
      reservationInvoiceDetails,
      reservationInvoiceDetailsLoading,
      reservationInvoiceDetailsMessage,
      reservationInvoiceDetailsFailed,
      reservationInvoiceDetailsError,
      // Temporary Save
      temporarySaveInoviceItemsLoading,
      temporarySaveInoviceItemsFailed,
      temporarySaveInoviceItemsError,
      temporarySaveInoviceItemsMessage,
      // Final Save
      finalSaveInoviceItemsLoading,
      finalSaveInoviceItemsFailed,
      finalSaveInoviceItemsError,
      finalSaveInoviceItemsMessage,
      reservationTemporaryReceipt,
      reservationFactorPrint,
    },
    menuItemsReducer: {
      menuItemsList,
      menuItemLoading,
      menuItemMessage,
      menuItemFailed,
      menuItemError,
    },
  } = useSelector(state => state);
  const [selectedDate, setSelectedDate] = useState(
    window.localStorage.getItem('shematic-date') ||
    jmoment(new Date()).format('jYYYY-jMM-jDD'),
  );

  useEffect(() => {
    return () => window.localStorage.removeItem('shematic-date');
  }, []);
  const { updateSocketReserve } = useSelector(state => ({
    updateSocketReserve: state.notificationsReducer.updateSocketReserve,
  }));
  const [selectedReserveId, setSelectedReserveId] = useState();
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);
  const [isShowInvoiceModal, setIsShowInvoiceModal] = useState(false);
  const [isShownTableStatusModal, setIsShownTableStatusModal] = useState(false);
  const [timeId, setTimeId] = useState('');
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [table, setTable] = useState([]);

  const dispatch = useDispatch();
  const fetchShematicData = useCallback(
    reserveDate => {
      dispatch(fetchIncominSchematicReservation(reserveDate));
    },
    [dispatch, fetchIncominSchematicReservation],
  );

  useEffect(() => {
    window.localStorage.setItem('shematic-date', selectedDate);
    fetchShematicData(selectedDate);
  }, [fetchShematicData, selectedDate, updateSocketReserve]);

  const handleSelectedDetail = reserveId => {
    setSelectedReserveId(reserveId);
    setIsShowInvoiceModal(false);
    setIsShowDetailModal(true);
  };

  const handleSelectedInvoice = reserveId => {
    setSelectedReserveId(reserveId);
    setIsShowDetailModal(false);
    setIsShowInvoiceModal(true);
    getReservationTemporaryPrint(reserveId, 'NOTPRINT');
  };

  const onSelectTableStatusModal = (
    timeId,
    fromTime,
    toTime,
    table,
  ) => {
    setIsShownTableStatusModal(true);
    setTimeId(timeId);
    setFromTime(fromTime);
    setToTime(toTime);
    setTable(table);
  };

  const getInvoiceDataByReserveId = async reserveId => {
    await Promise.all([
      dispatch(reservationActions.fetchReservationInvoiceDetails(reserveId)),
    ]);
  };

  const getReservationTemporaryPrint = async (reserveId, printMode) => {
    await Promise.all([
      dispatch(
        reservationActions.fetchReservationTemporaryPrint(reserveId, printMode),
      ),
    ]);
  };

  const getReservationFactorPrint = async reserveId => {
    await Promise.all([
      dispatch(reservationActions.fetchReservationFactorPrint(reserveId)),
    ]);
  };
  const getReservationTemporaryPrintByPrinterTarget = async (
    reserveId,
    printerTarget,
  ) => {
    await Promise.all([
      dispatch(
        reservationActions.fetchReservationTemporaryPrintByPrinterTarget(
          reserveId,
          printerTarget,
        ),
      ),
    ]);
  };

  const getMyCafeMenuItems = async () => {
    await Promise.all([
      dispatch(
        menuItemsActions.fetchAllMenuItems('pageNumber=1&pageSize=10000'),
      ),
    ]);
  };

  const handleTemporarySave = async (invoiceId, invoiceItems) => {
    return await dispatch(
      invoicesActions.temproraySaveInvoice(invoiceId, invoiceItems),
    );
  };

  const handleFinalSave = async (invoiceId, invoiceItems) => {
    await Promise.all([
      dispatch(invoicesActions.finalSaveInvoice(invoiceId, invoiceItems)),
    ]);
  };

  const handleCloseDetailModal = (isFetchData = false) => {
    if (isFetchData) {
      fetchShematicData(selectedDate);
    }
    setIsShowDetailModal(false);
  };

  const handleCloseInvoiceModal = (isFetchData = false) => {
    if (isFetchData) {
      fetchShematicData(selectedDate);
    }
    setIsShowInvoiceModal(false);
  };

  const handleCloseTableStatusModal = event => {
    event.preventDefault();
    setIsShownTableStatusModal(false);
  };

  return (
    <div>
      <section className='page-header'>
        <h1> {locales('titles.schematicReservation')}</h1>
      </section>
      <div className='my-3'>
        <div
          className='d-flex justify-content-start align-items-center '
          style={{ gap: '30px' }}
        >
          <span>{locales('date')}:</span>
          <span>
            <DatePicker
              marge={true}
              placeholder='انتخاب تاریخ'
              name='selectedDate'
              id='selectedDate'
              onChange={d =>
                setSelectedDate(jmoment(d).format('jYYYY-jMM-jDD'))
              }
              value={selectedDate}
              className='col-6'
              splitter='-'
            />
          </span>
      <ColorInfo />
        </div>
      </div>
      <List
        reserves={incomingSchematicReservationsList}
        loading={incomingSchematicReservationsLoading}
        onSelectedDetail={handleSelectedDetail}
        // onSelectedInvoice={handleSelectedInvoice}
        onSelectTableStatusModal={onSelectTableStatusModal}
      />
      {isShowDetailModal && (
        <ReserveDetailsModal
          isOpen={isShowDetailModal}
          reserveId={selectedReserveId}
          close={handleCloseDetailModal}
        />
      )}

      {isShowInvoiceModal && (
        <InvoiceDetailsModal
          isOpen={isShowInvoiceModal}
          close={handleCloseInvoiceModal}
          getInvoiceDataByReserveId={getInvoiceDataByReserveId}
          getReservationTemporaryPrint={getReservationTemporaryPrint}
          getReservationFactorPrint={getReservationFactorPrint}
          getReservationTemporaryPrintByPrinterTarget={
            getReservationTemporaryPrintByPrinterTarget
          }
          getMyCafeMenuItems={getMyCafeMenuItems}
          temproraySave={handleTemporarySave}
          finalSave={handleFinalSave}
          invoiceData={reservationInvoiceDetails}
          fetchDataLoading={reservationInvoiceDetailsLoading}
          fetchDataMessage={reservationInvoiceDetailsMessage}
          fetchDataFailed={reservationInvoiceDetailsFailed}
          fetchDataError={reservationInvoiceDetailsError}
          reservationTemporaryReceipt={reservationTemporaryReceipt}
          reservationFactorPrint={reservationFactorPrint}
          menuItemsList={menuItemsList}
          getMenuItemsLoading={menuItemLoading}
          getMenuItemsMessage={menuItemMessage}
          getMenuItemsFailed={menuItemFailed}
          getMenuItemsError={menuItemError}
          temporarySaveLoading={temporarySaveInoviceItemsLoading}
          temporarySaveFailed={temporarySaveInoviceItemsFailed}
          temporarySaveError={temporarySaveInoviceItemsError}
          temporarySaveMessage={temporarySaveInoviceItemsMessage}
          finalSaveLoading={finalSaveInoviceItemsLoading}
          finalSaveFailed={finalSaveInoviceItemsFailed}
          finalSaveError={finalSaveInoviceItemsError}
          finalSaveMessage={finalSaveInoviceItemsMessage}
          reserveId={selectedReserveId}
          cafeName={reservationInvoiceDetails.cafeName}
          invoiceId={reservationInvoiceDetails.id}
          invoiceNo={reservationInvoiceDetails.num}
          customerFullName={reservationInvoiceDetails.customerFullName}
          customerMobileNumber={reservationInvoiceDetails.customerMobileNumber}
          individualsCount={reservationInvoiceDetails.reservePersons}
          tablesNum={reservationInvoiceDetails.reservedTables}
          meal={reservationInvoiceDetails.reserveMeal}
          reserveDate={reservationInvoiceDetails.reserveDate}
          reserveStartAt={reservationInvoiceDetails.reserveStartAt}
          reserveEndAt={reservationInvoiceDetails.reserveEndAt}
          reserveStatus={reservationInvoiceDetails.reserveStatus}
          invoiceStatus={reservationInvoiceDetails.invoiceStatus}
          trackingNumber={reservationInvoiceDetails.reserveTrackingNumber}
          reserveType={reservationInvoiceDetails.reserveType} // TODO
          subTotalPrice={reservationInvoiceDetails.subTotalPrice}
          toBePaidToCafePrice={reservationInvoiceDetails.toBePaidToCafePrice}
          hourlyDiscountAmount={reservationInvoiceDetails.hourlyDiscountsAmount}
          hourlyDiscountPercent={
            reservationInvoiceDetails.hourlyDiscountPercent
          }
          discountCodeAmount={reservationInvoiceDetails.discountCodeAmount}
          discountCodePercent={reservationInvoiceDetails.discountCodePercent} // TODO
          totalPrice={reservationInvoiceDetails.totalPrice}
          reserveBaseCost={reservationInvoiceDetails.reserveBaseCost}
          currency={reservationInvoiceDetails.currency} // TODO
          invoiceAdditions={reservationInvoiceDetails.invoiceAdditions} // TODO
          invoiceAdditionsAmount={
            reservationInvoiceDetails.invoiceAdditionsAmount
          } // TODO
          invoiceItems={reservationInvoiceDetails.invoiceItems} // TODO
          menuItems={reservationInvoiceDetails.menuItems} // TODO
          notes={reservationInvoiceDetails.notes}
          rseePercent={reservationInvoiceDetails.rseePercent}
          rseeStockAmount={reservationInvoiceDetails.rseeStockAmount}
          balanceAmount={reservationInvoiceDetails.balanceAmount}
          invoiceDiscountCodeAmount={
            reservationInvoiceDetails.invoiceDiscountCodeAmount
          }
          totalEntranceAmount={reservationInvoiceDetails.totalEntranceAmount}
        />
      )}

      {isShownTableStatusModal && (
        <HandelTableTimeStatus
          isOpen={isShownTableStatusModal}
          close={handleCloseTableStatusModal}
          timeId={timeId}
          fromTime={fromTime}
          toTime={toTime}
          table={table}
        />
      )}
    </div>
  );
};

export default SchematicReservation;
